module.exports = __webpack_public_path__ + "files/20eb75772163acd0ae6cc24c25752ffd.png";